import { authGet } from '../utils/fecth-wrappers';
import constants from '../constants/appConstants';

export const getRelatedDealers = () => {
  return authGet(constants.API.relatedDealers);
};
